export default [
  {
    name: 'factoring/confirm',
    path: '/factoring/confirm',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/factoring/Confirm.vue'),
  },
  {
    name: 'factoring/success',
    path: '/factoring/success',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/factoring/Success.vue'),
  },
  {
    name: 'factoring/failure',
    path: '/factoring/failure',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/factoring/Failure.vue'),
  },
  {
    name: 'factoring/evaluation',
    path: '/factoring/evaluation',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/factoring/Evaluation.vue'),
  },
]
